import { render, staticRenderFns } from "./CellRendererEmail.vue?vue&type=template&id=107953af&"
import script from "./CellRendererEmail.vue?vue&type=script&lang=js&"
export * from "./CellRendererEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports